exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.carrello-nr[data-v-6052de38]{\n    bottom: -8px;\n    font-size: 12px;\n}\n\n", ""]);

// exports
